import { useEffect, useRef } from 'react';

import { useAuth as useOidcAuth } from 'react-oidc-context';

import LoadingPage from '@/components/common/LoadingPage';

export default function LoginDialog() {
  const { signinRedirect } = useOidcAuth();
  const didRedirect = useRef(false);

  useEffect(() => {
    if (didRedirect.current) return;

    didRedirect.current = true;

    localStorage.clear();
    signinRedirect();
  }, [signinRedirect]);

  return <LoadingPage />;
}
